module.exports = __webpack_public_path__ + "static/img/cha.a97de93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/cha.png
// module id = k1FA
// module chunks = 1